import VueDragscroll from 'vue-dragscroll';
import { type App } from 'vue'; 

export const initVueDragscroll = (app: App<Element>) => {
    app.use(VueDragscroll);
};
  